module.exports = __webpack_public_path__ + "static/media/get-refund-image.52a6aa1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/get-refund-image.jpg
// module id = 1425
// module chunks = 0